import axiosClient from './axiosClient'

const menuApi = {
  getAll: () => axiosClient.get('menus'),
  updatePositoin: (params) => axiosClient.put('menus', params),
}

export default menuApi